<article>
  <table mat-table [dataSource]="channels()" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nom du support</th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__channel"
      >
        <div>
          <img
            [ngSrc]="element.logoUrl || '/assets/images/broken-image.svg'"
            [alt]="element.name"
            [height]="40"
            [width]="40"
            class="mat-table-container__channel-logo"
          />

          <section>
            <span>
              {{ element.name }}
            </span>
            <span class="mat-table-container__channel__created-at">
              Créé le : {{ element.createdAt | date: 'dd/MM/YYYY' }}
            </span>
          </section>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="country">
      <th mat-header-cell *matHeaderCellDef>Pays</th>
      <td mat-cell *matCellDef="let element">
        {{ (element.country | isoToCountry) || '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="mediaType">
      <th mat-header-cell *matHeaderCellDef>Média</th>
      <td mat-cell *matCellDef="let element">
        {{ element.mediaType | mediaType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          type="button"
          (click)="onRowClick(element)"
          matTooltip="Voir"
          aria-label="Voir"
        >
          <img [lazyLoad]="'assets/icons/eye.svg'" alt="View" />
        </button>
        <button
          type="button"
          matTooltip="Modifier"
          (click)="openEditDialog(element)"
        >
          <img [lazyLoad]="'assets/icons/pen-to-square.svg'" alt="edit" />
        </button>
        <button
          type="button"
          matTooltip="Supprimer"
          (click)="openDeleteDialog(element)"
        >
          <img [lazyLoad]="'assets/icons/trash.svg'" alt="trash" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
